import classNames from "classnames";
import PropTypes from "prop-types";
import { ArrowMoreIcon } from "../../icons";
import { handleEvent } from "@gx1/gx-npm-lib";
import { TypographyComponent } from "../typography/typography.component";
import styles from "./textLink.styles.module.scss";

const variantType = {
  primary: "primary",
  secondary: "secondary",
  tertiary: "tertiary",
  dark: "dark",
};
const propTypes = {
  ariaLabel: PropTypes.string,
  disabled: PropTypes.bool,
  href: PropTypes.string,
  onClick: PropTypes.func,
  rootClassName: PropTypes.string,
  target: PropTypes.string,
  text: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  variant: PropTypes.oneOf(Object.values(variantType)),
  isMasked: PropTypes.bool,
};

/**
 * @deprecated DO NOT USE, DO NOT UPDATE
 */
const TextLink = ({
  ariaLabel = "",
  disabled = false,
  href = "",
  onClick = (..._args) => { },
  rootClassName = "",
  target = "",
  text = "",
  variant = variantType.primary,
  isMasked = false,
}) => {
  variant = variantType[variant] ? variant : variantType.primary;
  const styling = variant === variantType.secondary ? "p4" : "p3";
  const boldness = [variantType.primary, variantType.secondary, variantType.dark].includes(variant)
    ? "medium"
    : "regular";
  return (
    <a
      aria-label={ariaLabel || null}
      disabled={disabled}
      className={classNames(
        "gx-text-link",
        rootClassName,
        styles.textLink,
        disabled && "disabled",
        disabled && styles.disabled,
        variant,
        {
          [styles.primary]: variant === variantType.primary,
          [styles.secondary]: variant === variantType.secondary,
          [styles.tertiary]: variant === variantType.tertiary,
          [styles.dark]: variant === variantType.dark,
        }
      )}
      href={href || null}
      onClick={(e) => handleEvent(onClick, e)}
      onKeyDown={(e) => {
        if (e.key === "Enter") {
          handleEvent(onClick, e);
        }
      }}
      rel={target === "_blank" ? "noreferrer" : null}
      target={target || null}
      tabIndex={0}
      {...(isMasked ? { "data-amp-mask-attributes": "href" } : {})}
    >
      <TypographyComponent isMasked={isMasked} styling={styling} boldness={boldness}>
        {text}
      </TypographyComponent>
      {variant === variantType.secondary && <ArrowMoreIcon />}
    </a>
  );
};

TextLink.propTypes = propTypes;
export { TextLink, variantType as variantTypeTextLink };
